import React, { Fragment, useEffect, useState } from "react";
import BlockHeader from "../../component/BlockHeader/BlockHeader";
import "../../sass/form/form.scss";
import api from '../../api';
import EditProfile from "component/EditProfile";
import { useSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import { popinfo } from "../../component/Fancybox/Fancybox";
import _ from "lodash";

export default () => {
    const[profile, setProfile]          = useState(false);
    const[eligibility, setEligibility] = useState(true);

    let [searchParams]  = useSearchParams();
    let navigate        = useNavigate();
    let location        = useLocation();


    useEffect(() => {

        if(!searchParams.get('u') || !searchParams.get('t') || !searchParams.get('service'))
        {
            setEligibility('QUERY_INCOMPLETE');
        }
        else
        {
            api('/Account/Step-1', 'get', {
                u : searchParams.get('u')
                ,t : searchParams.get('t')
                ,service : searchParams.get('service')
            })
                .then(function(Response){    
                    setProfile(Response.user);
                })
                .catch((error) => {
                    setEligibility('PROFILE_ERROR');
                });

        }

    }, []);

    return (
            <div id="profile-basic-info-form" className="container w-800">
                {
                    eligibility === true ?
                        <Fragment>
                            <span className="registration-step text-sm block mb-md">Step 1 of 3</span>
                            <BlockHeader title={"Profile Completion"} desc="Before exploring further, please complete your profile below" />                    
                            <div className="text-sm">
                                <span className="bold">Or,</span> You can <Link className="color-brand" to={"declare-interest" + location.search }>skip</Link>  for now 
                            </div>
                            <EditProfile 
                                profile={profile} 
                                onSubmit={values => {
                                    var SavingLoader = popinfo('loader', 'Saving Profile', 'Please Wait');
            
                                    api('/Account/Step-1', 'post', _.assignIn(values, {
                                        u : searchParams.get('u')
                                        ,t : searchParams.get('t')
                                        ,service : searchParams.get('service')
                                    }))
                                        .then(function(response){
                                            SavingLoader.close();
                        
                                            navigate('declare-interest' + location.search)
                                        })
                                        .catch((error) => {
                                            popinfo('error', 'Saving Data', error, {}, SavingLoader);
                                        });
                                }}
                            />
                        </Fragment>
                    :
                        <div className="leading-text text-md text-center bold">
                            { eligibility == 'PROFILE_ERROR' && <span className="textarea">Invalid token found</span> }
                            { eligibility == 'QUERY_INCOMPLETE' && <span className="textarea">Missing identification token on URL</span> }
                        </div>

                }
            </div>
    )
}